// Flagship live + virtual cohort — most marketing points here.
export const NOV_EVENT = {
  start: "2026-11-09",
  end: "2026-11-15",
  startISO: "2026-11-09T10:00:00",
  dateLabel: "9–15 November 2026",
  venue: "Nashat African Cultural Centre",
  address: "101 Church St, Croydon CR0 1RN",
  format: "In-person + Live Virtual",
  course: "nlp_practitioner",
  mapQuery: "Nashat African Cultural Centre, 101 Church St, Croydon CR0 1RN",
};

export const EVENT_MAP_SRC =
  "https://www.google.com/maps?q=" + encodeURIComponent(NOV_EVENT.mapQuery) + "&output=embed";
